import { useNavigate } from "react-router-dom";
import "./ImageLinks.css";

function ImageLinks() {
  const navigate = useNavigate();

  return (
    <div className="image-links-container">

      <div className="image-card" onClick={() => navigate("/academics")}>
        <img src="/images/acadamics.png" alt="Academics" />
        <h3>Academics</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/links")}>
        <img src="/images/usefullink.png" alt="Useful Links" />
        <h3>Useful Links</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/contact")}>
        <img src="/images/contact-us.png" alt="Contact Us" />
        <h3>Contact Us</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/about")}>
        <img src="/images/aboutus.png" alt="About Us" />
        <h3>About Us</h3>
      </div>

    </div>
  );
}

export default ImageLinks;
